import { Component, ViewContainerRef, TemplateRef} from '@angular/core';
import { Shippment } from '../../models/shippment/shippment-model';
import { ShippmentService } from '../../services/shippment/shippment-setting';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ProfileService } from '../../services/profile/profile.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-edit-shippment-method',
    templateUrl: './edit-shippment-method.component.html',
    styleUrls: ['./edit-shippment-method.component.css']
})
/** edit-shippment-method component*/
export class EditShippmentMethodComponent {
    /** edit-shippment-method ctor */
  public shippment = new Shippment();
  fileToUpload: File;
  fd = new FormData();
  userId: number;
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  selectedShippmentLogo: string;
  ediShippmentLogo: string;
  validate: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  constructor(private _avRoute: ActivatedRoute, private _router: Router,public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly shippmentService: ShippmentService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("shippingmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.getShippmentById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
              this.validate = true;
            }
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this._router.navigate(["/shipping-methods"]);
          }
        }
        else {
          this._router.navigate(["/shipping-methods"]);
        }
      }
    )
  }
  getShippmentById(id: string) {
    this.shippmentService.getShippmentById(id).subscribe(
      data => {
        this.shippment = data;
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.ediShippmentLogo = Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }
  HidePopup() {
    this.selectedShippmentLogo = "";
    this.ediShippmentLogo = "";
    this.modalRef.hide();
  }

  ShowImage() {
    this.shippment.logo = this.ediShippmentLogo;
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  uploadShippmentLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("ShippmentLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.shippment.logo = "";
      this.mediaImageShow = true;
      this.selectedShippmentLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.shippment.url = Value.toLowerCase();
  }
  isActiveCheckbox(e) {
    this.shippment.isActive = e.target.checked;
  }
  isDefaultCheckbox(e) {
    this.shippment.isDefault = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.shippmentService.updateShippment(this.shippment).subscribe(result => {
      if (result) {
        this.toastr.success('Shippmernt Method has been Updated. ', 'Success');
        this.fd.append("ShippingMethodID", result.toString());
        this.shippmentService.AddShippmentLogo(this.fd, this.userId);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shipping-components/edit-shippment-method/edit-shippment-method.component.ts